import { MsalAuthenticationTemplate, MsalProvider, UnauthenticatedTemplate } from "@azure/msal-react";
import { loginRequest } from "authConfig";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import store from "redux/store";
import App from "./App";
import "swiper/css";
import { GlobalProvider } from "ContextApi/GlobalContext";
import { Loading } from "@carbon/react";
import { msalInstance, initializeMsal } from "./msalClient";

const root = ReactDOM.createRoot(document.getElementById("root"));

initializeMsal().then(() => {
  root.render(
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate interactionType="redirect" authenticationRequest={loginRequest}>
        <Provider store={store}>
          <GlobalProvider>
            <App />
          </GlobalProvider>
        </Provider>
      </MsalAuthenticationTemplate>
      <UnauthenticatedTemplate>
        <Loading withOverlay active />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
});
